export const REGISTERS_EXPORT_HEADS = [
  { id: "id", label: "ID" },
  { id: "anonymousIndividualGender", label: "Sexo (Anônimo)" },
  { id: "anonymousGroupMembersNumber", label: "Número de Membros do Grupo" },
  { id: "latitude", label: "Latitude" },
  { id: "longitude", label: "Longitude" },
  { id: "type", label: "Tipo" },
  { id: "registerDate", label: "Data do Registro" },
  { id: "environment", label: "Ambiente" },
  { id: "observations", label: "Observações" },
  { id: "sampleCollected", label: "Amostra Coletada" },
  { id: "lastEditor", label: "Último Editor" },
  { id: "attachmentsCount", label: "Quantidade de Anexos" },
  { id: "reporterId", label: "ID do Relator" },
  { id: "individualId", label: "ID do Indivíduo" },
  {
    id: "anonymousIndividualTaxonomicGroupId",
    label: "ID do Grupo Taxonômico (Anônimo)",
  },
  { id: "createdAt", label: "Criado em" },
  { id: "updatedAt", label: "Atualizado em" },
];
